var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallerySelectedImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24958 17.5004C4.64853 17.5004 3.2245 16.4754 2.70748 14.9493L2.67248 14.8343C2.55048 14.4303 2.49948 14.0903 2.49948 13.7503V6.93213L0.0734133 15.0303C-0.238595 16.2214 0.472424 17.4564 1.66545 17.7854L17.1289 21.9265C17.3219 21.9765 17.5149 22.0005 17.7049 22.0005C18.7009 22.0005 19.6109 21.3395 19.8659 20.3655L20.767 17.5004H6.24958Z",
    fill: "#95A4C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99981 7.0001C10.1028 7.0001 10.9999 6.10308 10.9999 5.00005C10.9999 3.89702 10.1028 3 8.99981 3C7.89678 3 6.99976 3.89702 6.99976 5.00005C6.99976 6.10308 7.89678 7.0001 8.99981 7.0001Z",
    fill: "#95A4C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0H6.49958C5.12154 0 3.99951 1.12203 3.99951 2.50007V13.5004C3.99951 14.8784 5.12154 16.0004 6.49958 16.0004H21.5C22.878 16.0004 24 14.8784 24 13.5004V2.50007C24 1.12203 22.878 0 21.5 0ZM6.49958 2.00005H21.5C21.776 2.00005 22 2.22406 22 2.50007V9.59925L18.8409 5.91316C18.5059 5.52014 18.0209 5.31014 17.4999 5.29814C16.9819 5.30114 16.4958 5.53115 16.1638 5.92916L12.4497 10.3873L11.2397 9.18024C10.5557 8.49622 9.44266 8.49622 8.75964 9.18024L5.99956 11.9393V2.50007C5.99956 2.22406 6.22357 2.00005 6.49958 2.00005Z",
    fill: "#95A4C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallerySelectedImg);
export default __webpack_public_path__ + "static/media/gallerySelectedImg.9c159e31777478c873b233302cf1962a.svg";
export { ForwardRef as ReactComponent };